import React from 'react';
import Switch from '../../ui/Switch';

// Teams PR A: the small shared controls for the Teams screens. A choice is a row of hollow pills; the chosen one gets the
// platform's green outline (.ia-selected-pill) and aria-pressed, so the state is never colour-only.
export function PillGroup({ label, options, value, onChange, disabled = false, testId }) {
    return (
        <div className="ia-teams__pills" role="group" aria-label={label} data-testid={testId}>
            {label && <span className="ia-teams__pills-label">{label}</span>}
            {options.map(([key, text]) => (
                <button
                    key={key}
                    type="button"
                    className={`ia-teams__pill${value === key ? ' ia-selected-pill' : ''}`}
                    aria-pressed={value === key}
                    data-pill={key}
                    disabled={disabled}
                    onClick={() => onChange(key)}
                >
                    {text}
                </button>
            ))}
        </div>
    );
}

export function SwitchRow({ label, checked, onChange, disabled = false, hint = null, id }) {
    return (
        <div className="ia-teams__line">
            <span className="ia-teams__line-label" id={id ? `${id}-label` : undefined}>
                {label}
                {hint && <span className="ia-teams__hint block">{hint}</span>}
            </span>
            <Switch checked={checked} onChange={onChange} aria-label={label} disabled={disabled} />
        </div>
    );
}
